"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShoppingProps = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailedEvent = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var LoyaltyDialogResultEvent = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ShoppingContextLoadedEvent = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("./constants");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useShoppingProps = ({
  initialQuantity,
  loadingEvents,
  productCode
}) => {
  const [counterValue, setCounterValue] = (0, _react.useState)(_constants.COUNTER_MIN_VALUE);
  const [initialMaxQuantity, setInitialMaxQuantity] = (0, _react.useState)(_constants.DEFAULT_COUNTER_MAX_VALUE);
  const [maxQuantity, setMaxQuantity] = (0, _react.useState)(initialMaxQuantity);
  const [disabled, setDisabled] = (0, _react.useState)(false);
  const [loading, setLoading] = (0, _react.useState)(false);
  const onBasketChange = (0, _react.useCallback)((shoppingBag, shouldSetInitialMaxQuantity) => {
    const {
      maxProductQuantity,
      shoppingBagItems
    } = shoppingBag;
    const item = (0, _utils.findShoppingBagItem)({
      productCode,
      shoppingBagItems
    });
    (0, _utils.updateCounterData)({
      counterValue,
      maxProductQuantity,
      shouldSetInitialMaxQuantity,
      item,
      setCounterValue,
      setDisabled,
      setInitialMaxQuantity,
      setMaxQuantity
    });
  }, [counterValue, productCode]);
  const onBasketUpdated = (0, _react.useCallback)(({
    detail: {
      shoppingBag
    }
  }) => {
    onBasketChange(shoppingBag, false);
    setLoading(false);
    setCounterValue(_constants.COUNTER_MIN_VALUE);
  }, [onBasketChange]);
  const onShoppingContextLoaded = (0, _react.useCallback)(({
    detail: {
      shoppingBag
    }
  }) => {
    onBasketChange(shoppingBag, true);
  }, [onBasketChange]);
  const onLoyaltyDialogClose = (0, _react.useCallback)(event => {
    if (event.detail.result === LoyaltyDialogResultEvent.LoyaltyDialogResults.CLOSE) {
      setLoading(false);
    }
  }, []);
  const onAddToBasket = (0, _react.useCallback)(_ => {
    setLoading(true);
  }, []);
  const onAddToBasketFailed = (0, _react.useCallback)(_ => {
    setLoading(false);
  }, []);
  (0, _react.useEffect)(() => {
    window.dispatchEvent(new CustomEvent(RequestShoppingContextEvent.Name));
  }, []);
  (0, _react.useEffect)(() => {
    if (initialQuantity != null) {
      setCounterValue(initialQuantity > maxQuantity ? maxQuantity : initialQuantity);
    }
  }, [initialQuantity, maxQuantity]);
  const events = (0, _react.useMemo)(() => [{
    name: BasketUpdatedEvent.Name,
    listener: onBasketUpdated
  }, {
    name: ShoppingContextLoadedEvent.Name,
    listener: onShoppingContextLoaded
  }, {
    name: AddToBasketEvent.Name,
    listener: onAddToBasket
  }, {
    name: AddToBasketFailedEvent.Name,
    listener: onAddToBasketFailed
  }, {
    name: LoyaltyDialogResultEvent.Name,
    listener: onLoyaltyDialogClose
  }, ...(loadingEvents ?? []).map(eventName => ({
    name: eventName,
    listener: onAddToBasket
  }))], [loadingEvents, onAddToBasket, onAddToBasketFailed, onBasketUpdated, onLoyaltyDialogClose, onShoppingContextLoaded]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    counterValue,
    disabled,
    loading,
    maxQuantity,
    setCounterValue
  };
};
exports.useShoppingProps = useShoppingProps;
//# sourceMappingURL=hooks.js.map